 import {createIconSetFromFontello} from '../../Helpers/PlatformSynchronizer';
import fontelloConfig from './config.json';
 export default createIconSetFromFontello(fontelloConfig);
